<script>
import { formatThousands } from '@/utils/helpers'

export default {
  name: 'RexSlider',
  props: {
    label: {
      type: String,
      default: () => null
    },
    railLabel: {
      type: String,
      default: () => null
    },
    boundaryValues: {
      type: Array,
      default: () => ([0, 100])
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => 'getField',
    },
    setterName: {
      type: String,
      default: () => 'setField'
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    targetFields: {
      type: Array,
      default: () => ([]),
      required: true
    },
    valuesSuffix: {
      type: String,
      default: () => null
    },
    interval: {
      type: Number,
      default: () => 1
    },
    valuesFormatter: {
      type: Function,
      default: () => null
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
    hasCustomValuesFormatter: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    renderValues: [0, 1]
  }),
  computed: {
    value: {
      get() {
        const result = [
          this.$store.getters[`${this.storeModule}/${this.getterName}`](`${this.target}.${this.targetFields[0]}`),
          this.$store.getters[`${this.storeModule}/${this.getterName}`](`${this.target}.${this.targetFields[1]}`)
        ]

        this.updateRenderValues(result)

        return result
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: `${this.target}.${this.targetFields[0]}`,
          value: value[0]
        })
        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: `${this.target}.${this.targetFields[1]}`,
          value: value[1]
        })
      }
    }
  },
  methods: {
    updateRenderValues(values) {
      this.renderValues = values.map(value => (this.hasCustomValuesFormatter
        ? this.valuesFormatter(value)
        : formatThousands(value)))
    },
    change() {
      this.$emit('change', {
        event: this.value,
        element: this.$vnode.elm
      })
    }
  }
}
</script>
<template>
  <b-field
    custom-class="rex-label"
    :label="label"
  >
    <div class="rex-slider">
      <span
        v-if="railLabel"
        class="rex-slider__rail-label"
      >
        {{ railLabel }}
      </span>
      <b-slider
        v-model="value"
        :min="boundaryValues[0]"
        :max="boundaryValues[1]"
        :step="interval"
        :tooltip="false"
        :disabled="isDisabled"
        lazy
        @dragging="updateRenderValues"
        @dragend="change"
      />
      <div
        class="rex-slider__values"
        :class="{
          'rex-slider__values--disabled': isDisabled
        }"
      >
        <p>
          {{ renderValues[0] }}
          <span
            v-if="valuesSuffix"
          >
            {{ valuesSuffix }}
          </span>
        </p>
        <p>
          {{ renderValues[1] }}
          <span
            v-if="valuesSuffix"
          >
            {{ valuesSuffix }}
          </span>
        </p>
      </div>
    </div>
  </b-field>
</template>